import type { ComboBoxValueComponentProps } from '../../../cdl/ComboBox/types/ComboBoxComponentProps';
import { Text } from '../../../cdl/Text/Text';
import { AgentImportedLabel } from '../../../common/AgentImportedLabel/AgentImportedLabel';
import { Box } from '../../../common/ui/Box';
import type { AgentSelectOption } from '../AgentSelectOption';

export const AgentValue = ({ option }: ComboBoxValueComponentProps<AgentSelectOption>) => (
    <Box display="flex" justifyContent="space-between" gap={8} alignItems="center" minWidth={0} width="100%">
        <Text
            display="block"
            variant="small"
            style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
            {option.label}
        </Text>
        {option.agent?.source ? (
            <Box flexShrink={0}>
                <AgentImportedLabel />
            </Box>
        ) : null}
    </Box>
);
